"use strict";
/* @ngInject */
function institutionService(API_URL, $http) {
    return function (tenantId) {
        return $http.get(API_URL.institution + "/" + tenantId + "?query={\"product\":15}")
            .then(function (response) { return response.data; });
    };
}
exports.institutionService = institutionService;



/** WEBPACK FOOTER **
 ** ./app/common/institution/institution-service.ts
 **/